import { v4 as uuidv4 } from 'uuid';

class BotMessage {
  constructor(step, message, alternatives = []) {
    this.step = step;
    this.message = message;
    this.alternatives = alternatives;
  }

  toKamiObject() {
    return {
      Kami: [
        {
          text: this.message,
          alternatives: this.alternatives,
          createdAt: new Date(),
          id: uuidv4(),
          step: this.step,
        },
      ],
      id: uuidv4(),
    };
  }

  toJsObject() {
    return {
      text: this.message,
      alternatives: this.alternatives,
      createdAt: new Date(),
      id: uuidv4(),
      step: this.step,
    };
  }
}

export default BotMessage;
